import { Button, Card, Input, Tooltip, message } from 'antd';
import React, { FC, useCallback, useMemo, useState } from 'react';
import './index.less';

interface InternalWorkOrderNotesAsTranscriptProps {
	id: string;
	tooltipMessage: string;
	title: string;
	allowEdit?: boolean;
	loading?: boolean;
	notes: string;
	onSaveNotes?: (notes: string) => any;
	onSaveSuccess?: (result: any) => any;
	okTextSuffix?: string;
	useRichText?: boolean;
	style?: any;
	currentUser?: any;
}

const InternalWorkOrderNotesAsTranscript: FC<InternalWorkOrderNotesAsTranscriptProps> = ({
	id,
	tooltipMessage,
	title,
	allowEdit,
	loading,
	notes,
	onSaveNotes,
	onSaveSuccess,
	style = {},
	currentUser,
}) => {
	const [saving, setSaving] = useState(false);
	const [noteInput, setNoteInput] = useState('');
	const addNote = () => {
		if (!noteInput.trim()) return;
		const userDisplayName = `${currentUser.nameGiven} ${currentUser.nameFamily} (${currentUser.email})`;
		const newNote = `${noteInput.trim()}\n <span> - ${userDisplayName} </span>`;
		setNoteInput('');
		setNoteInput('');
		if (onSaveNotes) {
			setSaving(true);
			onSaveNotes(notes ? `${notes}\n\n${newNote}` : newNote)
				.then((res) => onSaveSuccess && onSaveSuccess(res))
				.catch(() => message.error('Failed to save notes'))
				.finally(() => {
					setSaving(false);
				});
		}
	};

	return (
		<Card
			bordered
			style={{ whiteSpace: 'pre-line', minHeight: 150 }}
			title={title}
			loading={loading}
		>
			<div style={{ maxWidth: 500, margin: '0 auto' }}>
				<div
					className={'richTextWrapper'}
					dangerouslySetInnerHTML={{
						__html: notes || 'No notes yet...',
					}}
				/>

				{allowEdit ? (
					<div className="mt-6">
						<Input.TextArea
							rows={1}
							value={noteInput}
							onChange={(e) => setNoteInput(e.target.value)}
							placeholder="Add a note..."
							style={{ marginTop: 10 }}
							autoSize
						/>
						<Button
							type="primary"
							onClick={addNote}
							style={{ marginTop: 16, width: '100%' }}
							loading={saving}
						>
							Add Note
						</Button>
					</div>
				) : null}
			</div>
		</Card>
	);
};

export default InternalWorkOrderNotesAsTranscript;
